import { render, staticRenderFns } from "./TipoLote.vue?vue&type=template&id=6d285763"
import script from "./TipoLote.vue?vue&type=script&lang=js"
export * from "./TipoLote.vue?vue&type=script&lang=js"
import style0 from "./TipoLote.vue?vue&type=style&index=0&id=6d285763&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports